var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put } from 'redux-saga/effects';
import { getConfigurationDataSuccessAction, getConfigurationDataFailureAction } from '../actions';
import { STYLE } from '../constants';
import { BrandedNotificationWorkflowTypes, BrandedNotificationWorkflowSubTypes } from '../enums';
import { BrandedNotificationGetService } from '../services';
function fetchBrandedNotificationConfiguration(brandedNotificationService, brandedNotificationInputs, coCode) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield brandedNotificationService.getBrandedNotificationConfiguration(brandedNotificationInputs, coCode);
    });
}
export function* fetchBrandedNotificationConfigurationSaga(action, branbedNotificationService = new BrandedNotificationGetService()) {
    const { brandedNotificationInputs, coCode, defaultProfileData } = action.payload;
    try {
        const response = yield call(fetchBrandedNotificationConfiguration, branbedNotificationService, brandedNotificationInputs, coCode);
        if (response.hasOwnProperty('result')) {
            if (response.result.status) {
                yield put(getConfigurationDataSuccessAction(response.result.brandedNotificationDetails));
            }
            else {
                yield put(getConfigurationDataFailureAction(response.result.errorResponse.errorResponse));
            }
        }
        else if (!Object.keys(response).length && defaultProfileData) {
            const response = {
                coCode: '',
                styleData: { profileId: '', profileName: '', profileData: '' },
                contentData: { profileId: '', profileName: '', profileData: '' },
                failureMessage: '',
                templateDetailList: [],
                notificationLanguage: '',
                workflowType: BrandedNotificationWorkflowTypes.PBE,
                workflowSubType: BrandedNotificationWorkflowSubTypes.WELCOME,
                notificationType: '',
                contentType: '',
                isLoading: false,
                recipientType: ''
            };
            if (brandedNotificationInputs.contentType === STYLE) {
                response.styleData.profileData = defaultProfileData;
            }
            else {
                response.contentData.profileData = defaultProfileData;
            }
            yield put(getConfigurationDataSuccessAction(response));
        }
    }
    catch (error) {
        yield put(getConfigurationDataFailureAction(error));
    }
}
//# sourceMappingURL=fetchBrandedNotificationCofigurationSaga.js.map